module.exports = __webpack_public_path__ + "img/hair_color_green.62d95a2.svg";